import type { ReactNode } from "react";

import { STUDIO_COLOR_HEX } from "@/components/dashboard/monolithBoardStyle";
import { Button } from "@/components/ui/Button";

function SectionTitle({ children, id }: { children: ReactNode; id: string }) {
  return (
    <h2
      id={id}
      className="scroll-mt-6 text-xl font-semibold uppercase tracking-[0.2em] [font-family:var(--color-lab-display),system-ui,sans-serif]"
    >
      {children}
    </h2>
  );
}

function NoticeBoardPanel() {
  return (
    <article
      className="relative bg-[#fffaf1] p-6 shadow-[4px_6px_16px_rgba(19,19,19,0.16)] sm:p-7"
      style={{
        transform: "rotate(-1.2deg)",
        clipPath:
          "polygon(0 0, 100% 0, 100% calc(100% - 8px), 92% 100%, 84% calc(100% - 3px), 74% 100%, 62% calc(100% - 5px), 50% 100%, 38% calc(100% - 2px), 28% 100%, 18% calc(100% - 4px), 8% 100%, 0 calc(100% - 6px))",
      }}
    >
      <span
        className="absolute left-1/2 top-0 z-10 -translate-x-1/2 -translate-y-1/3 rounded-full border-2 border-neutral-950 shadow-[0_2px_4px_rgba(0,0,0,0.25)]"
        style={{
          width: 14,
          height: 14,
          background: `radial-gradient(circle at 40% 35%, ${STUDIO_COLOR_HEX.russetGold}, ${STUDIO_COLOR_HEX.accentSecondary})`,
        }}
      />

      <p className="text-[10px] uppercase tracking-[0.28em] text-neutral-600">Notice</p>
      <h3 className="mt-2 text-xl font-bold uppercase tracking-tight [font-family:var(--color-lab-display),system-ui,sans-serif]">
        Expedition Charter
      </h3>
      <p className="mt-3 text-sm leading-relaxed text-neutral-800">
        The party departs at dawn from the Greenwall Gate. Provisions for seven days have been
        secured. The cartographer will mark all discovered landmarks on the master map upon return.
      </p>
      <div className="mt-6 flex flex-wrap items-center gap-3 border-t-2 border-neutral-950/12 pt-6">
        <Button variant="primary" chrome="frame" type="button">
          Ratify
        </Button>
        <Button variant="cancel" chrome="frame" type="button">
          Decline
        </Button>
      </div>
    </article>
  );
}

export function SavedForLaterClient() {
  return (
    <div className="mx-auto min-h-full max-w-5xl px-5 py-12 pb-24 text-neutral-950 sm:px-8">
      <header className="border-b-[3px] border-neutral-950 pb-10">
        <p className="text-[11px] uppercase tracking-[0.28em] text-neutral-600">
          Design system &middot; Saved
        </p>
        <h1 className="mt-4 text-4xl font-bold leading-tight tracking-tight [font-family:var(--color-lab-display),system-ui,sans-serif] sm:text-5xl">
          Saved for later
        </h1>
        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-neutral-800">
          Prototyped UI treatments that have not yet been promoted into production components but are
          worth keeping for future use.
        </p>
      </header>

      <div className="mt-14 space-y-20">
        <section className="space-y-8" aria-labelledby="notice-board">
          <SectionTitle id="notice-board">Notice board panel</SectionTitle>
          <p className="max-w-2xl text-neutral-800">
            A pinned, slightly rotated panel with a torn bottom edge and wax-pin ornament. Evokes a
            tavern bulletin or posted notice. Could be used for alerts, quest boards, or community
            announcements.
          </p>
          <div className="flex justify-center py-6">
            <div className="w-full max-w-lg">
              <NoticeBoardPanel />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
